var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icone-component"},[_c('div',[_c('div',{staticClass:"icone-title",style:({ color: _vm.color, 'background-color': _vm.bgcolor })},[_c('i',{staticClass:"fa fa-lg",class:_vm.icone,attrs:{"aria-hidden":"true"}})])]),_c('div',{staticClass:"title is-size-4 has-text-weight-medium"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }